<template>
  <div v-if="isLoading">
    <loading :active.sync="isLoading" color="#6666ff" :is-full-page="fullPage"></loading>
  </div>
  <div class="is-fullhd" v-else>
    <div class="box">
      <div class="content has-text-centered">
        <h2 class="is-title is-bold has-text-centered has-text-primary">
          Manage Member(s)
        </h2>
      </div>
      <hr></hr>
      <div class="content">
        <p>
          Welcome to the Member edit page. From here you can add, modify or delete Team Member information. Simply click any of the highlighted fields. If you have any questions, <a @click="contactModal()">send us a message</a> and we’ll be right with you
        </p>
      </div>

      <div class="section" style="padding: 1rem 1rem 1rem 1rem; border: 1px solid whitesmoke; border-radius: 10px;">
        <div class="columns">
          <div class="column">
            <label class="label">Invite member by entering email address below</label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter email" v-model="members[0].email" :disabled="displayMembers.length > 10">
              <p class="control has-text-right">
                <a @click="inviteModal()">
                  <i class="fa fa-list-alt"></i> Email Preview
                </a>
              </p>
            </div>
          </div>
          <div class="column">
            <label class="label">&nbsp;</label>
            <div v-if="members[0].email !==''"  class="control">
              <button class="button is-primary" @click.prevent="addUser()">Invite Member</button>
            </div>
            <div v-if="members[0].email ===''"  class="control">
              <button class="button is-primary" disabled>Invite Member</button>
            </div>
          </div>
        </div>
        <p v-show="displayMembers.length > 10">
          You can add a maximum of 10 team members in the free risk assessment. <a @click="contactModal()">Contact us</a> to upgrade.
        </p>
      </div>
      <br/>
      <div class="content" v-if="displayMembers.length > 0">
        <div class="table-responsive invitedMemberTable">
          <small class="has-text-grey-light is-pulled-right">
            <a @click="remindModal()">
              <i class="fa fa-list-alt"></i> Reminder Preview
            </a>
          </small>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <!-- <th></th> -->
                <!-- <th style="width:125px;">Date Joined</th> -->
                <th>Member</th>
                <!-- <th>Role</th> -->
                <th style="min-width: 250px;">Status</th>
                <th colspan="2">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr class="list-group-item" v-for="(item, index) in displayMembers">
                <!-- <td class="is-icon" style="width:30px;">
                  {{index}}
                </td> 
                <td class="is-icon" style="width:100px;">
                  31-01-2020
                </td>-->
                <td>
                  {{item.member}}
                </td>
                <!-- <td v-if="item.status === 1">
                  <div class="field">
                    <div class="control">
                      <div class="select is-fullwidth">
                        <select v-model="item.role" disabled>
                          <option value="TL">Team Lead</option>
                          <option value="TM">Team Member</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </td>
                <td v-if="item.status !== 1">
                  <div class="field">
                    <div class="control">
                      <div class="select is-fullwidth">
                        <select v-model="item.role">
                          <option value="TL">Team Lead</option>
                          <option value="TM">Team Member</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </td> -->
                <td v-if="item.status === 1">
                  <span class="icon" style="color: #b5b5b5;">
                    <i class="fa fa-square"></i>
                  </span>
                  Invited (not joined)
                </td>
                <td v-if="item.status === 2">
                  <span class="icon" style="color: #fce473;">
                    <i class="fa fa-square"></i>
                  </span>
                  Assessment pending
                </td>
                <td v-if="item.status === 3">
                  <span class="icon has-text-primary">
                    <i class="fa fa-square"></i>
                  </span>
                  Assessment Submitted
                </td>
                <td class="is-icon">
                  <button v-if="item.role === 'TL' || item.status === 3" class="button is-primary is-small" disabled>
                    <i class="fa fa-bell"> Remind</i>
                  </button>
                  <button v-if="item.role !== 'TL' && item.status !== 3" class="button is-primary is-small">
                    <i class="fa fa-bell" @click="remind(item)" > Remind</i>
                  </button>
                </td>
                <td class="is-icon" style="width:30px;">
                  <button v-if="item.role !== 'TL'" class="button is-danger is-small">
                    <i class="fa fa-trash" @click="deleteUser(item)"> Remove</i>
                  </button>
                  <button v-if="item.role === 'TL'" class="button is-danger is-small" disabled>
                    <i class="fa fa-trash"> Remove</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div class="modal contactModal" :class="{ isActive: contactModalOpen }">
        <div class="modal-background"></div>
        <div class="modal-content">
          <div class="box">
            <div class="content">
              <h2 class="is-title is-bold has-text-centered has-text-primary">
                Contact Us
              </h2>
              <button class="delete" aria-label="close" @click="closeContactModal()"></button>
            </div>
            <hr></hr>
            <form>
              <div class="field">
                <label class="label">Your Message</label>
                <div class="control">
                  <textarea class="textarea" v-model="message" rows="3" placeholder="Your Message"></textarea>
                </div>
              </div>
              <div v-if="message" class="field">
                <div class="control has-text-centered">
                  <button @click.prevent="contactSubmit()" class="button is-primary">Send</button>
                </div>
              </div>
              <div v-if="!message" class="field">
                <div class="control has-text-centered">
                  <button class="button is-primary" disabled>Send</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      
      <div class="modal inviteModal" :class="{ isActive: inviteModalOpen }">
        <div class="modal-background"></div>
        <div class="modal-content">
          <div class="box is-paddingless">
            <div class="preview-header has-text-centered">
              <img src="https://www.changevu.com/img/logo2x.png" href="https://www.changevu.com/" alt="ChangeVU" width="150px">
              <button class="delete" aria-label="close" @click="closeInviteModal()"></button>
            </div>
            <div class="preview-banner has-text-centered">
              <img src="https://www.changevu.com/img/banners/changeLeaders.jpg" href="https://www.changevu.com/" alt="ChangeVU">
            </div>
            <div class="preview-body has-text-white">
              <div class="content">
                <h2 class="has-text-white">
                  You've been invited to join ChangeVU's change risk assessment.
                </h2>
                <p>
                  {{ this.user.firstName + ' ' + this.user.lastName }} invited you to run a team change risk assessment.
                </p>
                <p>
                  Click the link below to accept the invitation.<br />
                  Validate your email and password to access the change risk assessment.
                </p>
                <p>
                  You have until {{ this.initiative.deadline }} to complete the assessment.
                  <!--<br /> You will then receive your individual and team reports. -->
                </p>
                <table class="table">
                  <tbody>
                    <tr>
                      <td width="125px">Team Name:</td>
                      <td>{{ this.initiative.teamName }}</td>
                    </tr>
                    <tr>
                      <td width="125px">Team Leader:</td>
                      <td>{{ this.user.firstName }} {{ this.user.lastName }}</td>
                    </tr>
                    <tr>
                      <td width="125px">Initiative name:</td>
                      <td>{{ this.initiative.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="preview-body-button">
              <div class="content">
                <p class="has-text-centered">
                  <button class="button is-primary has-text-black">Accept Invitation</button>
                </p>
              </div>
            </div>
            <div class="preview-body has-text-white">
              <div class="content">
                <p>
                  Welcome to ChangeVU!<br /><br />
                  Thanks,<br />ChangeVU Team
                </p>
              </div>
            </div>
            <div class="preview-footer">
              <div class="footer-img">
                <img src="https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg" alt="Connect to better change navigation">
              </div>
              <p class="has-text-centered">
                <a href="#/teamInfo" style="color: #9B9B9B;">Unsubscribe</a> to stop receiving these emails from us.<br/>
                Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9<br/>
                © 2020 Straticom Technologies R&D, all rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal remindModal" :class="{ isActive: remindModalOpen }">
        <div class="modal-background"></div>
        <div class="modal-content">
          <div class="box is-paddingless">
            <div class="preview-header has-text-centered">
              <img src="https://www.changevu.com/img/logo2x.png" href="https://www.changevu.com/" alt="ChangeVU" width="150px">
              <button class="delete" aria-label="close" @click="closeRemindModal()"></button>
            </div>
            <div class="preview-banner has-text-centered">
              <img src="https://www.changevu.com/img/banners/blogs.jpg" href="https://www.changevu.com/" alt="ChangeVU">
            </div>
            <div class="preview-body has-text-white">
              <div class="content">
                <h2 class="has-text-white">
                  Reminder: Change Risk Assessment
                </h2>
                <p>
                  Hi there,
                </p>
                <p>
                   You've been invited by {{this.initiative.teamLead}} to a free change risk assessment.<br />
                   The deadline for completing the assessment is {{this.initiative.deadline}}
                </p>
                <p>
                  Click the button below to login and run your assessment.
                </p>
                <p style="margin-bottom: 0rem !important;">
                  Your team details:
                </p>
                <table class="table">
                  <tbody>
                    <tr>
                      <td width="125px">Team Name:</td>
                      <td>{{ this.initiative.teamName }}</td>
                    </tr>
                    <tr>
                      <td width="125px">Team Leader:</td>
                      <td>{{ this.initiative.teamLead }}</td>
                    </tr>
                    <tr>
                      <td width="125px">Initiative name:</td>
                      <td>{{ this.initiative.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="preview-body-button">
              <div class="content">
                <p class="has-text-centered">
                  <button class="button is-primary has-text-black">Run Assessment</button>
                </p>
              </div>
            </div>
            <div class="preview-body has-text-white">
              <div class="content">
                <p>
                  If you have any questions <a href="#/teamInfo" class="link">Click here.</a><br /><br />
                  Thanks,<br />ChangeVU Team
                </p>
              </div>
            </div>
            <div class="preview-footer">
              <div class="footer-img">
                <img src="https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg" alt="Connect to better change navigation">
              </div>
              <p class="has-text-centered">
                <a href="#/teamInfo" style="color: #9B9B9B;">Unsubscribe</a> to stop receiving these emails from us.<br/>
                Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9<br/>
                © 2020 Straticom Technologies R&D, all rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import Loading from 'vue-loading-overlay'

import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  data () {
    return {
      fullPage: true,
      isLoading: true,
      message: '',
      options: [],
      pictureName: '',
      pictureName2: '',
      onEditUser: {},
      contactModalOpen: false,
      inviteModalOpen: false,
      remindModalOpen: false,
      user: {
        firstName: '',
        lastName: '',
        email: ''
      },
      currentUser: {},
      initiative: {
        id: '',
        name: '',
        deadline: '',
        teamName: '',
        initiativeDetails: '',
        members: []
      },
      sortedMembers: [],
      members: [
        {
          email: ''
        }
      ],
      error: false
    }
  },
  created () {
    this.loadTeam()
  },
  computed: {
    displayMembers () {
      return this.sortedMembers
    }
  },
  methods: {
    loadTeam () {
      let user = JSON.parse(window.localStorage.getItem('user'))
      this.user = user
      this.sortedMembers.length = 0
      axios.get(globalConstants.apiURL + '/api/v1/createdInitiatives/' + user._id)
      .then(response => {
        if (response.data.length > 0) {
          this.initiative.id = response.data[0]._id
          this.initiative.teamLead = response.data[0].teamLead.firstName + ' ' + response.data[0].teamLead.lastName
          this.initiative.name = response.data[0].initiativeName
          this.initiative.deadline = new Date(response.data[0].deadline).toLocaleString()
          this.initiative.teamName = response.data[0].teamName
          this.initiative.members = response.data[0].members
          // not joined, status 1
          for (let j = 0; j < this.initiative.members.length; j++) {
            if (!this.initiative.members[j].user.joining) {
              this.sortedMembers.push({'member': this.initiative.members[j].user.email, 'role': 'TM', 'status': 1, 'action': true, 'id': this.initiative.members[j].user._id})
            }
          }
          for (let j = 0; j < this.initiative.members.length; j++) {
            if (this.initiative.members[j].user.joining && !this.initiative.members[j].user.diagonacticCompleted) {
              let role = 'TM'
              if (this.initiative.members[j].user.type === 'companyAdmin') {
                role = 'TL'
              }
              this.sortedMembers.push({'member': this.initiative.members[j].user.firstName + ' ' + this.initiative.members[j].user.lastName + ' (' + this.initiative.members[j].user.email + ')', 'role': role, 'status': 2, 'action': true, 'id': this.initiative.members[j].user._id})
            }
          }
          // Assessment complete, status 3
          for (let j = 0; j < this.initiative.members.length; j++) {
            if (this.initiative.members[j].user.joining && this.initiative.members[j].user.diagonacticCompleted) {
              let role = 'TM'
              if (this.initiative.members[j].user.type === 'companyAdmin') {
                role = 'TL'
              }
              this.sortedMembers.push({'member': this.initiative.members[j].user.firstName + ' ' + this.initiative.members[j].user.lastName + ' (' + this.initiative.members[j].user.email + ')', 'role': role, 'status': 3, 'action': false, 'id': this.initiative.members[j].user._id})
            }
          }
        }
        this.isLoading = false
      })
      .catch(error => {
        console.log(error)
      })
    },
    contactModal () {
      this.contactModalOpen = true
    },
    closeContactModal () {
      this.contactModalOpen = false
      this.message = ''
    },
    contactSubmit () {
      axios.post(globalConstants.apiURL + '/api/v1/submitContactForm', {name: this.user.firstName + ' ' + this.user.lastName, email: this.user.email, details: this.message})
      .then(response => {
        this.contactModalOpen = false
        this.message = ''
        this.$noty.success('Thanks for connecting with us. We will get back to you as soon as possible.')
      })
      .catch(error => {
        console.log(error)
      })
    },
    validateEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    addUser () {
      if (!this.validateEmail(this.members[0].email)) {
        this.$noty.error('Please enter valid email address.')
        this.members[0].email = ''
      } else {
        axios.post(globalConstants.apiURL + '/api/v1/invite', {inviter: this.user, members: this.members, initiativeID: this.initiative.id})
        .then(response => {
          this.loadTeam()
          // this.sortedMembers.unshift({member: this.members[0].email, role: 'TM', status: 1, action: true, id: response.data.invitedIDs[0]})
          this.$noty.success('Invitation email sent to join the risk assessment.')
          this.members[0].email = ''
        })
        .catch(error => {
          console.log('error on saving client' + error)
          this.$noty.error(error.response.data.message)
        })
      }
    },
    deleteUser (item) {
      let message = 'Are you sure you want to delete the user?'
      let options = {
        loader: true,
        okText: 'Yes',
        cancelText: 'No'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          axios.post(globalConstants.apiURL + '/api/v1/initiative/removeMember', {'initiativeID': this.initiative.id, 'userID': item.id})
            .then(response => {
              this.loadTeam()
              this.$noty.success('User removed successfully.')
              dialog.close()
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(() => {
        })
    },
    remind (item) {
      axios.post(globalConstants.apiURL + '/api/v1/remind', {inviter: this.user, 'initiativeID': this.initiative.id, 'userID': item.id})
        .then(response => {
          this.$noty.success('Reminder sent successfully.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    inviteModal () {
      this.inviteModalOpen = true
    },
    closeInviteModal () {
      this.inviteModalOpen = false
    },
    remindModal () {
      this.remindModalOpen = true
    },
    closeRemindModal () {
      this.remindModalOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.isActive {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.modal {
  top: 65px !important;
  height: 100%;
  @media screen and (max-width: 999px) {
    justify-content: flex-start;
    flex-direction: column;
    .modal-content {
      margin-top: 15%;
      max-height: calc(100vh - 160px) !important;
    }
  }
  .modal-content {
    // -ms-overflow-style: none;
    // scrollbar-width: none; 
    // overflow: -moz-scrollbars-none;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }
}

.name {
  color: #6666ff !important;
}

.invitedMemberTable {
  .table td, .table th {
    vertical-align: middle;
  }
  .table tr:hover {
    background: none;
  }
  table {
    margin-bottom: 0rem;
    border-collapse: separate;
    thead {
      tr {
        th {
          &:first-child {
            border-radius: 10px 0 0 0;
          }
          &:last-child {
            border-radius: 0 10px 0 0;
          }
        }
      }
    }
    tbody {
      tr:last-child {
        td {
          &:first-child {
            border-radius: 0px 0 0 10px;
          }
          &:last-child {
            border-radius: 0 0px 10px 0;
          }
        }
      }
    }
  }
}
.contactModal {
  .modal-content {
    border-radius: 10px;
    .box {
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0px;
      }
      p {
        margin-bottom: 1rem;
      }
    }
  }
}

.inviteModal {
  .modal-content {
    border-radius: 10px;
  }
  .preview-header {
    padding: 10px;
    position: relative;
    border-radius: 10px 10px 0px 0px;
    .delete {
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }
  .preview-banner {
    background-color: #6666ff;
  }
  .preview-body {
    background-color: #6666ff;
    padding: 1rem;
    .content {
      h2 {
        margin-bottom: 1rem !important;
      }
      p {
        margin-bottom: 1rem !important;
      }
      .table {
        background-color: transparent;
        color: #fff;
        line-height: 1;
        tr {
          &:hover {
            background-color: transparent !important;
          }
          border: none !important;
          td {
            border: none !important;
            padding: 0.25em 0em;
          }
        }
      }
    }
  }
  .preview-body-button {
    padding: 1.5rem 0rem;
    .button {
      font-weight: 600;
      font-size: 1.25rem;
    }
  }
  .preview-footer {
    color: #9B9B9B;
    background-color: #eee;
    padding: 0rem 0rem 1rem;
    border-radius: 0px 10px 10px 0px;
    a {
      text-decoration: underline;
    }
  }
}

.remindModal {
  .modal-content {
    border-radius: 10px;
  }
  .preview-header {
    padding: 10px;
    position: relative;
    border-radius: 10px 10px 0px 0px;
    .delete {
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }
  .preview-banner {
    background-color: #6666ff;
  }
  .preview-body {
    background-color: #6666ff;
    padding: 1rem;
    .content {
      h2 {
        margin-bottom: 1rem !important;
      }
      p {
        margin-bottom: 1rem !important;
      }
      .table {
        background-color: transparent;
        color: #fff;
        line-height: 1;
        tr {
          &:hover {
            background-color: transparent !important;
          }
          border: none !important;
          td {
            border: none !important;
            padding: 0.25em 0em;
          }
        }
      }
      .link {
        color: #FFF !important;
        font-weight: 600;
        text-decoration: underline;
        font-size: 14px;
      }
    }
  }
  .preview-body-button {
    padding: 1.5rem 0rem;
    .button {
      font-weight: 600;
      font-size: 1.25rem;
    }
  }
  .preview-footer {
    color: #9B9B9B;
    background-color: #eee;
    padding: 0rem 0rem 1rem;
    border-radius: 0px 10px 10px 0px;
    a {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// teamMembers.vue?c1556a4a